import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';
import {Observable} from 'rxjs/Observable';
import {tap} from 'rxjs/operators';

@Injectable()
export class MstPatientService {
    mstPatient: any;
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'mst_patient/list/?';
    private AddRecord = webapi + 'mst_patient/create';
    private EditRecord = webapi + 'mst_patient/update';
    private GetRecord = webapi + 'mst_patient/byid/';
    private DeleteRecord = webapi + 'mst_patient/delete/';
    private ListRecordByColumnName = webapi + 'mst_patient/search?';
    private GetRecordServiceByMrNo = webapi + 'mst_patient/getrecordservicebymrno/?';
    private GetRecordServiceBynationalid = webapi + 'mst_patient/getrecordservicebynationalid/?';
    private GetRecordServiceBymobileno = webapi + 'mst_patient/getrecordservicebymobileno/?';
    private GetRecordServiceBymykadid = webapi + 'mst_patient/getrecordservicebymykadid/?';
    private GetRecordServiceByemailid = webapi + 'mst_patient/getrecordservicebyemailid/?';
    private lastvisitautocompleteMR = webapi + 'mst_patient/lastvisitautocompleteMR?'; //  Jay
    private lastvisitautocompleteMRUnit = webapi + 'mst_patient/lastvisitautocompleteMRbyUnitId?'; //  Jay
    private lastvisitautocompleteName = webapi + 'mst_patient/lastvisitautocompleteName?'; //  Jay
    private lastvisitautocompleteNameUnitId = webapi + 'mst_patient/lastvisitautocompleteNamebyUnitId?'; //  Jay
    private lastvisitautocompletePhone = webapi + 'mst_patient/lastvisitautocompletePhone?'; //  Jay
    private lastvisitautocompletePhoneUnitId = webapi + 'mst_patient/lastvisitautocompletePhonebyUnitId?'; //  Jay
    private lastvisitautocompleteMobile = webapi + 'mst_patient/lastvisitautocompleteMobile?'; //  Jay
    private lastvisitautocompleteMobileUnit = webapi + 'mst_patient/lastvisitautocompleteMobilebyUnit?'; //  Jay
    private lastvisitautocompleteID = webapi + 'mst_patient/lastvisitautocompleteID?'; //  Jay
    private lastvisitautocompleteIDUnit = webapi + 'mst_patient/lastvisitautocompleteIDbyUnit?'; //  Jay
    private lastvisitautocompleteEmail = webapi + 'mst_patient/lastvisitautocompleteEmail?'; //  Jay
    private lastvisitautocompleteEmailUnit = webapi + 'mst_patient/lastvisitautocompleteEmailbyUnit?'; //  Jay
// Rahul Emr Billing
    private lastemrvisitautocompleteMR = webapi + 'mst_patient/lastemrvisitautocompleteMR?'; //  Jay
    private lastemrvisitautocompleteName = webapi + 'mst_patient/lastemrvisitautocompleteName?'; //  Jay
    private lastemrvisitautocompletePhone = webapi + 'mst_patient/lastemrvisitautocompletePhone?'; //  Jay
    private lastemrvisitautocompleteMobile = webapi + 'mst_patient/lastemrvisitautocompleteMobile?'; //  Jay
    private lastemrvisitautocompleteID = webapi + 'mst_patient/lastemrvisitautocompleteID?'; //  Jay
    private lastemrvisitautocompleteEmail = webapi + 'mst_patient/lastemrvisitautocompleteEmail?'; //  Jay
    private IssueECardByPatientId = webapi + 'mst_patient/issueESmartCard/';
    private SearchRecordByAutoMrPatientUnitId = webapi + 'mst_patient/searchPatientByautocompleteMRUnitId/?';
    private SearchRecordByAutoNamePatientUnitId = webapi + 'mst_patient/searchPatientByautocompleteNameUnitId/?';
    private SearchRecordByAutoMobilePatientUnitId = webapi + 'mst_patient/searchPatientByautocompleteMobileUnitId/?';
    private GetAutocomplitebymrnamemobileunit = webapi + 'mst_patient/patientsearchbymrnamemobile/';

    constructor(
        private http: Http
    ) {
    }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any) {
        return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordByColumnName(currentPage: any, size: any, qString: any, sort: any, col: any, colname: any): Promise<any> {
        // console.log(this.ListRecordByColumnName + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&colname=' + colname);
        return this.http.get(this.ListRecordByColumnName + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&colname=' + colname)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordServiceByMrNo(qString: any): Promise<any> {
        return this.http.get(this.GetRecordServiceByMrNo + '&qString=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordServiceBynationalid(nationalid: any): Promise<any> {
        return this.http.get(this.GetRecordServiceBynationalid + '&qString=' + nationalid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordServiceBymobileno(mobileno: any): Promise<any> {
        return this.http.get(this.GetRecordServiceBymobileno + '&qString=' + mobileno)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordServiceBymykadid(mykadid: any): Promise<any> {
        return this.http.get(this.GetRecordServiceBymykadid + '&qString=' + mykadid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordServiceByemailid(mailid: any): Promise<any> {
        return this.http.get(this.GetRecordServiceByemailid + '&qString=' + mailid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

//  Author : Jay
    getLastRecordForAutoMR(qString: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteMR + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    getLastRecordForAutoMRByUnit(qString: any, unitId: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteMRUnit + 'searchString=' + qString + '&unitId=' + unitId)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Jay
    getLastRecordForAutoName(qString: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteName + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //Hemant
    getLastRecordForAutoNamebyUnitId(qString: any, unitId: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteNameUnitId + 'searchString=' + qString + '&unitId=' + unitId)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Jay
    getLastRecordForAutoPhone(qString: any): Observable<any> {
        return this.http.get(this.lastvisitautocompletePhone + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    getLastRecordForAutoPhoneByUnit(qString: any, unitId: any): Observable<any> {
        return this.http.get(this.lastvisitautocompletePhone + 'searchString=' + qString + '&unitId=' + unitId)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Jay
    getLastRecordForAutoMobile(qString: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteMobile + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    getLastRecordForAutoMobilebyUnitId(qString: any, unitId: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteMobileUnit + 'searchString=' + qString + '&unitId=' + unitId)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Jay
    getLastRecordForAutoID(qString: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteID + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    getLastRecordForAutoIDByUnit(qString: any, unitId: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteIDUnit + 'searchString=' + qString + '&unitId=' + unitId)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Jay
    getLastRecordForAutoEmail(qString: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteEmail + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //Hemant
    getLastRecordForAutoEmailByUnit(qString: any, unitId: any): Observable<any> {
        return this.http.get(this.lastvisitautocompleteEmailUnit + 'searchString=' + qString + '&unitId=' + unitId)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Rahul
    getEmrLastRecordForAutoMR(qString: any): Observable<any> {
        return this.http.get(this.lastemrvisitautocompleteMR + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Rahul
    getEmrLastRecordForAutoName(qString: any): Observable<any> {
        return this.http.get(this.lastemrvisitautocompleteName + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Rahul
    getEmrLastRecordForAutoPhone(qString: any): Observable<any> {
        return this.http.get(this.lastemrvisitautocompletePhone + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Rahul
    getEmrLastRecordForAutoMobile(qString: any): Observable<any> {
        return this.http.get(this.lastemrvisitautocompleteMobile + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Rahul
    getEmrLastRecordForAutoID(qString: any): Observable<any> {
        return this.http.get(this.lastemrvisitautocompleteID + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    //  Author : Rahul
    getEmrLastRecordForAutoEmail(qString: any): Observable<any> {
        return this.http.get(this.lastemrvisitautocompleteEmail + 'searchString=' + qString)
            .map(response => response.json())
            .pipe(
                tap(
                    error => this.logError(error)
                ));
    }

    onIssueECard(id: any) {
        return this.http.put(this.IssueECardByPatientId + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    searchPatientByautocompleteMRUnitId(qString: any, unitId: any) {
        return this.http.get(this.SearchRecordByAutoMrPatientUnitId + 'qString=' + qString + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    searchPatientByautocompleteNameUnitId(qString: any, unitId: any) {
        return this.http.get(this.SearchRecordByAutoNamePatientUnitId + 'qString=' + qString + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    searchPatientByautocompleteMobileUnitId(qString: any, unitId: any) {
        return this.http.get(this.SearchRecordByAutoMobilePatientUnitId + 'qString=' + qString + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAutocomplitebymrnamemobileunit(mrno: any, unitId: any): Promise<any> {
        return this.http.get(this.GetAutocomplitebymrnamemobileunit + mrno + '/' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }

    private logError(error: Response | any) {
        return Observable.throw(error.message || error);
    }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mst-patient/mst-patient.service.ts